<template>
  <el-form-item :prop="getProp" :rules="rules" :class="{'hidden':component.properties.sortType==='hidden','to-top':component.properties.sortType==='toTop'}" :label="component.properties.sortType==='hidden' ? '' : component.name" :title="component.name">
     <el-tooltip class="component-explain-tooltip" v-if="component.properties.componentExplain" :content="component.properties.componentExplain" placement="bottom-start">
        <span class="fa fa-question-circle"></span>
      </el-tooltip>
     <el-switch class="el-switch-runtime"  @change="changeSwitch" v-model="formatterValue" :disabled="component.properties.readonly"></el-switch>
    </el-form-item>
</template>

<script>
import { componentMixin, inputMixin, calculationMixin, defaultValueMixin } from './mixins'

export default {
  name: 'rc-switch',
  props: ['component', 'value', 'disabled'],
  mixins: [ componentMixin, inputMixin, calculationMixin, defaultValueMixin ],
  data () {
    return {
      formatterValue: this.value === '是'
    }
  },
  watch: {
    'value' (val) {
      if (val !== '' && val !== undefined && val !== null) {
        this.formatterValue = val === '是'
      }
    }
  },
  methods: {
    initComponent () {
      if (this.value === '' || this.value === undefined || this.value === null) {
        this.changeSwitch(this.component.properties.isOpen)
      }
    },
    changeSwitch (val) {
      this.formatterValue = val
      let newValue = val === true ? '是' : '否'
      this.update(newValue)
      // 触发值改变事件
      this.$nextTick(() => this.executeFunctions('change'))
    }
  }
}
</script>
<style lang="scss">
.el-rate-runtime {
  margin-top: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/form/runtime/components/rc-switch.vue